"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "novi-velia": {
    "e268b1e4": [{
      "hkey": "e43588b4",
      "slug": "novi-velia",
      "name": "Novi Velia",
      "primary": true,
      "skipSearch": false
    }],
    "madonna-del-sacro-monte-di-novi-velia": [{
      "hkey": "e43588b4",
      "slug": "novi-velia",
      "name": "Novi Velia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;